import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import APIExtensions from "../yoello-lib/modules/API2/APIDefs";
import { useAPIV2 } from "../yoello-lib/modules/API2/useAPIv2";
import { HTTPMethods } from "../yoello-lib/modules/API/API";
import { IReduxAppState } from "../reducers";
import { setDisabledRoutes } from "../actions/disabledRoutes";
import { MenuContainerTabs } from "../components/Routes";

const taxesKey = MenuContainerTabs.TAXES.key;

/**Hook for determing if the user needs to migrate tax bands */
export function useTaxes(venueId: string) {
    const dispatch = useDispatch();
    /**call fees API */
    const { callAPI: callFees } = useAPIV2(APIExtensions.migrationsFees, { onMountDisabled: true });
    /**Call items API */
    const { callAPI: callItems } = useAPIV2(APIExtensions.migrationItems, { onMountDisabled: true });
    const isFeesNotMigrated = useSelector((state: IReduxAppState) => state.migrations.isMigrateFees);
    const isItemsNotMigrated = useSelector((state: IReduxAppState) => state.migrations.isMigrateItems);
    useEffect(() => {
        if(venueId){
            callFees(HTTPMethods.GET, {
                yoelloAPIParams: { venue_id: venueId }
            });
            callItems(HTTPMethods.GET, {
                yoelloAPIParams: { venue_id: venueId }
            });
        }
        //eslint-disable-next-line
    }, [venueId]);
    useEffect(() => {
        if (isFeesNotMigrated || isItemsNotMigrated) {
            dispatch(setDisabledRoutes([taxesKey]));
        }
        //eslint-disable-next-line
    }, [isFeesNotMigrated, isItemsNotMigrated]);

}